import { createRef, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalComponent from "src/core/components/modal/modal.component";
import TableComponent from "src/core/components/table/table.component";
import { faClipboard } from "@fortawesome/free-regular-svg-icons";

import TableSort from "src/shared/helpers/table-sort";
// import capitalizeFirst from "src/shared/helpers/upper-case";

import { getBlocksBySiteCode } from "../../../../../store/slices/location-block.slice";
import { getSiteByTCCode } from "../../../../../store/slices/location-site.slice";
import { getTownCouncils } from "../../../../../store/slices/town-council.slice";

import * as yup from "yup";
import FilterFormComponent, {
  FilterFormConfig,
} from "src/shared/filter-form/filter-form.component";
import { getAssetsByBlockWithSupplierId } from "src/core/api/services/dashbaorad-details/location-block.services";
import { useQuery } from "@tanstack/react-query";
import { publishOta } from "src/store/slices/ota.slice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SkeletonComponent from "src/shared/custom-spinner/skeleton.component";

const OtaPublishComponent = ({ otaPublishStates }: any) => {
  const {
    isOTAPublishModalOpen,
    setIsOTAPublishModalOpen,
    selectedIdToDeleteOrEdit,
    onRefetchData,
    data,
  } = otaPublishStates;

  const formRef = createRef();

  const [PageNumber, setPageNumber] = useState<number>(1);
  const pageSize = 10;
  const [filterUpdateCount, setFilterUpdateCount] = useState(0);

  // const [SortBy, setSortBy] = useState<any>(capitalizeFirst("firmwareVersion"));
  // const [SortDirection, setSortDirection] = useState<any>("desc");

  const [blockSelected, setBlockSelected] = useState<string>("");
  const [supplierSelected, setSupplierSelected] = useState<number>(-1);

  const [otaPublished, setOtaPublished] = useState(false);

  const [formFilterInitialValues, setFormFilterInitialValues] = useState({
    townCouncil: "",
    site: "",
    block: "",
  });

  const [columns, setColumns] = useState([
    {
      title: "Address",
      label: "address",
      // width: "9rem"
    },
    {
      title: "Asset ID",
      label: "assetID",
      // width: "9rem"
    },
    {
      title: "Display Name",
      label: "sensorDisplayName",
      // width: "9rem"
    },
    {
      title: "Status",
      label: "status",
    },
  ]);

  const [tcOptions, setTCOptions] = useState<any>([]);
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const [blockOptions, setBlockOptions] = useState<any>([]);

  //****  Modal Properties *******
  const handleClose = () => {
    setIsOTAPublishModalOpen(false);
  };

  const handlePublish = () => {
    const gatewaysArray = selectedItems?.map((item: any) => item.value);

    // console.log(selectedIdToDeleteOrEdit, selectedItems, gatewaysArray);
    //  ;
    const payload = {
      id: Number(selectedIdToDeleteOrEdit),
      gateways: gatewaysArray,
    };

    dispatch(publishOta({ payload })).then(() => {
      onRefetchData();
      handleClose();
    });
  };

  const actionConfig = [
    {
      label: "Publish",
      event: handlePublish,
      variant: "success",
      disabled: !otaPublished,
    },
  ];

  // *********************

  //****  FormBuilder Properties *******
  const validationSchema = yup.object().shape({
    townCouncil: yup.string().required("Town Council is required"),
    site: yup.string().required("Site is required"),
    block: yup.string().required("Block is required"),
  });

  const dispatch = useDispatch();

  const {
    data: assetsByBlockResponse,
    isLoading: isLoadingAssetByBlockResponse,
  } = useQuery({
    queryKey: ["getAssetsByBlockService", blockSelected, supplierSelected],
    // queryFn: ({ signal }) => getAssetsByBlockService(blockSelected, signal),
    queryFn: ({ signal }) =>
      getAssetsByBlockWithSupplierId(blockSelected, supplierSelected, signal),
  });

  useEffect(() => {
    dispatch(getTownCouncils({ PageNumber: 0, pageSize: 0 }));
  }, [dispatch]);

  const townCouncilData = useSelector((state: any) => {
    return state.townCouncil.townCouncils;
  });

  const isLoadingTownCouncils = useSelector((state: any) => {
    return state.townCouncil.isLoadingTownCouncils;
  });

  const siteDataByTCCode = useSelector((state: any) => {
    return state.locationSite.sitesByTCCode;
  });

  const isLocationSitesByTCCode = useSelector((state: any) => {
    return state.locationSite.isLocationSitesByTCCode;
  });

  const blockDataSiteCode = useSelector((state: any) => {
    return state.locationBlock.blocksBySiteCode;
  });

  const isLoadingBlocksBySiteCode = useSelector((state: any) => {
    return state.locationBlock.isLoadingBlocksBySiteCode;
  });

  const onChangeTC = (selectedTC: any) => {
    setSiteOptions([]);
    setBlockOptions([]);

    const form: any = formRef.current;

    if (form) {
      // Get all field names except 'towncouncil'
      const fieldNames = Object.keys(form.values).filter(
        (name) => name !== "towncouncil"
      );

      // Reset each field to empty, except 'towncouncil'
      fieldNames.forEach((fieldName) => {
        if (fieldName === "site" || fieldName === "block") {
          form.setFieldValue(fieldName, "", false); // false to avoid validation after setting field
        }
      });

      // console.log(form.values); // This will now reflect the reset operation
    }

    setFormFilterInitialValues({
      ...formFilterInitialValues,
      townCouncil: selectedTC,
      site: "",
      block: "",
    });

    dispatch(getSiteByTCCode({ tcCode: selectedTC }));
  };

  const onChangeSite = (selectedSite: any) => {
    setBlockOptions([]);

    setFormFilterInitialValues({
      ...formFilterInitialValues,
      site: selectedSite,
      block: "",
    });

    dispatch(getBlocksBySiteCode({ siteCode: selectedSite }));
  };

  const onChangeBlock = (selectedBlock: any) => {
    // setBlockSelected(selectedBlock);
  };

  const formConfiguration: FilterFormConfig = {
    controls: [
      {
        controlGroup: [
          {
            name: "townCouncil",
            placeholder: "Select Town Council *",
            type: "searchable-select",
            options: tcOptions,
            onChange: onChangeTC,
            required: true,
            isLoading: isLoadingTownCouncils,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "site",
            placeholder: "Select Site *",
            type: "searchable-select",
            options: siteOptions,
            onChange: onChangeSite,
            required: true,
            isLoading: isLocationSitesByTCCode,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "block",
            placeholder: "Select Block *",
            type: "searchable-select",
            options: blockOptions,
            onChange: onChangeBlock,
            required: true,
            isLoading: isLoadingBlocksBySiteCode,
          },
        ],
      },
    ],
  };
  const [currentTC, setCurrentTC] = useState({ label: "", value: "" });

  useEffect(() => {
    const tcs = townCouncilData?.data?.map((tc: any) => ({
      label: tc?.name,
      value: tc?.tcCode,
    }));

    if (!tcs) return;

    // if user is TC Admin only 1 tc is available
    if (tcs?.length === 1) {
      setCurrentTC(tcs[0]);
    }

    const optionsWithEmptyString = [
      { label: "Select Town Council *", value: "" },
      ...tcs,
    ];

    setTCOptions(optionsWithEmptyString);
    setFilterUpdateCount(filterUpdateCount + 1);
  }, [townCouncilData]);

  useEffect(() => {
    if (currentTC.value.length) {
      setFormFilterInitialValues((prev) => ({
        ...prev,
        townCouncil: currentTC.value,
      }));

      dispatch(getSiteByTCCode({ tcCode: currentTC.value }));
    }
  }, [currentTC]);

  useEffect(() => {
    const sites = siteDataByTCCode?.data?.map((site: any) => ({
      label: site?.name,
      value: site?.siteCode,
    }));

    if (!sites?.length) return;

    const optionsWithEmptyString = [
      { label: "Select Site *", value: "" },
      ...sites,
    ];

    setSiteOptions(optionsWithEmptyString);
  }, [siteDataByTCCode]);

  useEffect(() => {
    const blocks = blockDataSiteCode?.data?.map((block: any) => ({
      label: block?.blockName,
      value: block?.blockCode,
    }));

    if (!blocks) return;
    const optionsWithEmptyString = [
      { label: "Select Block *", value: "" },
      ...blocks,
    ];

    setBlockOptions(optionsWithEmptyString);
  }, [blockDataSiteCode]);

  const onReset = () => {
    const form: any = formRef.current;
    form.resetForm();
    setFilterUpdateCount(filterUpdateCount + 1);

    setFormFilterInitialValues({
      townCouncil: "",
      site: "",
      block: "",
    });

    // dispatch(setFilter({}));
    setSiteOptions([]);
    setBlockOptions([]);
  };

  const onSubmitFilter = () => {
    const form: any = formRef.current;

    const { townCouncil, site, block } = form.values;

    if (form) {
      form.handleSubmit();

      if (!townCouncil || !site || !block) {
        return;
      }

      const otaDetails = data.find(
        (item: any) => item.id === selectedIdToDeleteOrEdit
      );
      setSupplierSelected(otaDetails?.supplierId);
      setBlockSelected(block);
      setOtaPublished(true);
    }
  };

  useEffect(() => {
    if (!assetsByBlockResponse) return;
    // console.log(assetsByBlockResponse[0]?.assets);
    //  ;
  }, [assetsByBlockResponse]);

  const filterActionConfig: any = {
    label: "Filter",
    event: onSubmitFilter,
    variant: "primary",
  };

  const reset: any = {
    label: "Reset",
    event: onReset,
    variant: "secondary",
  };

  // *********************

  //****  TableComponent Properties *******

  const selectedItems = useSelector((state: any) => state.table.selectedItems);

  useEffect(() => {
    dispatch({
      type: "table/toggleSelectAll",
      payload: [],
    });
  }, [dispatch]);

  const emptyConfig = {
    title: "No Gateway Found",
    description: "",
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNumber(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      // setSortBy(sortBy);
      // setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  // *********************

  return (
    <ModalComponent
      showModal={isOTAPublishModalOpen}
      handleClose={() => handleClose()}
      headerTitle={"Publish OTA"}
      size="lg"
      actionConfig={actionConfig}
    >
      <>
        <FilterFormComponent
          key={formFilterInitialValues?.townCouncil}
          formRef={formRef}
          initialValues={formFilterInitialValues}
          validation={validationSchema}
          formConfig={formConfiguration}
          actionConfig={filterActionConfig}
          resetButton={reset}
          filterUpdateCount={filterUpdateCount}
        />
        <SkeletonComponent
          wrapperHeight="550px"
          skeletonHeight="550px"
          width="100%"
          isLoading={isLoadingAssetByBlockResponse}
        >
          {assetsByBlockResponse ? (
            <TableComponent
              tableHeaders={columns}
              emptyConfig={emptyConfig}
              data={assetsByBlockResponse[0]?.assets}
              totalNumberOfRecords={assetsByBlockResponse[0]?.totalCount}
              pageSize={pageSize}
              current={PageNumber}
              onChangePage={handleChangePage}
              onChangeSort={handleChangeSort}
              enableSelection={true}
              isLoadingData={isLoadingAssetByBlockResponse}
            />
          ) : (
            <div className="flex justify-center items-center">
              <div
                className="flex flex-col justify-center items-center"
                style={{
                  width: "80%",
                  padding: "5rem",
                  borderRadius: "8px",
                  backgroundColor: "#EBEBEB",
                }}
              >
                <div style={{ fontSize: "70px" }}>
                  <FontAwesomeIcon icon={faClipboard} className="mb-3" />
                </div>
                <h2 style={{ fontWeight: 700 }}>Please Select Gateway</h2>
                {/* <div>{emptyConfig?.description}</div> */}
              </div>
            </div>
          )}
        </SkeletonComponent>
      </>
    </ModalComponent>
  );
};

export default OtaPublishComponent;
